module.exports = __webpack_public_path__ + "static/fourth_user_image4-58c04c92245c6b8b1ba7992d7456639f.jpg";